import { Component, Input, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SearchService } from '../../../services/search.service';
import { ProductService } from '../../../services/products/product.service';
import { Products } from '../../../../models/product.model';
import { FeatherIconsComponent } from '../../feather-icons/feather-icons.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'app-search-small-header',
  imports: [FeatherIconsComponent, RouterModule,CommonModule, FormsModule],
  templateUrl: './search-small-header.component.html',
  styleUrls: ['./search-small-header.component.scss']
})

export class SearchSmallHeaderComponent {

  @Input() isSearchOpen:boolean;

  public productList: Products[]=[];
  public text: string;
  public searchResult = false;
  public searchResultEmpty = false;
  private sortFilter:string;

  constructor( public searchService : SearchService,private _router:Router,
    private _productService:ProductService){ }


  findProducts(value:string){
    value ? this.addFix() : this.removeFix();
    if (!value) return (this.productList = []);
    this._productService.filter(value,this.sortFilter,undefined,8).subscribe({
      next: (response) => {
        this.checkSearchResultEmpty(response.data);
        this.productList=response.data;
        this.text=value;
      },
      error: ({error}) => {
      },
    })

    return;
  }
  

  checkSearchResultEmpty(items: Products[]) {
    if (!items.length) this.searchResultEmpty = true;
    else this.searchResultEmpty = false;
  }

  addFix() {
    this.searchResult = true;
    document.body.classList.add("offcanvas");
  }

  clickOutside(): void {
    this.text = "";
    this.searchResult = false;
    this.searchResultEmpty = false;
    document.body.classList.remove("offcanvas");
  }

  removeFix() {
    this.text = "";
    this.searchResult = false;
    document.body.classList.remove("offcanvas");
  }
  redirectToSearch({value}:any){
    window.scrollTo(0, 0);
    this._router.navigate(["/search"],{ queryParams: { search: value } })
  }
}
